import { useState } from 'react'
import {connect, Field} from 'formik'
import {FormCheckbox, FormGroup, FormTextArea} from './'

export const MessageField = ({ config }) => {
  if (!config.showMessageField) return null

  const [expanded, setExpanded] = useState(config.expandMessageField)

  return expanded ? <MessageInput config={config} /> : <Toggle setExpanded={setExpanded} />
}

const MessageInput = connect(({ config }) => {
  return <div className='mb-6'>
    {config.showDisplayName &&
      <Field name='display_name' placeholder={I18n.t('donate.attributes.display_name')} component={FormGroup} />}

    <Field name='message' className='form-control donate-message-field' placeholder={I18n.t('donate.attributes.message')} component={FormTextArea} />
    <Field name='show_amount' className='inline-block mr-3' label={I18n.t('donate.show_amount.label')} component={FormCheckbox} />
    {!config.showDisplayName &&
      <Field name='show_user' className='inline-block' label={<ShowUserLabel fields={['first_name', 'last_name', 'company_name']} />} component={FormCheckbox} />}
  </div>
})

// Delete if field should be expanded over the long term
const Toggle = ({ setExpanded }) => {
  return <div className='mb-6 text-right'>
    <span className='simulated-link font-weight-400 small' onClick={() => setExpanded(true)}>
      {I18n.t('donate.message_field.toggle_link')}
    </span>
  </div>
}

const ShowUserLabel = connect(({ formik }) => {
  const displayName = formik.values._company_donation ?
    formik.values.company_name :
    (formik.values.first_name + ' ' + formik.values.last_name.substring(0, 1) + (formik.values.last_name && '.'))
  const trimmedDisplayName = displayName.length > 18 ? displayName.substring(0, 18) + '...' : displayName

  return <>
    {I18n.t('donate.show_user.label') + (displayName.length > 1 ? ': ' : '') + trimmedDisplayName}
  </>
})
